import { PageHeader } from "@/components/dashboard/page-header";
import { SearchList } from "@/components/dashboard/search-list";
import { ErrorState } from "@/components/dashboard/state";
import { clientApi } from "@/lib/client-api";
import { useQuery } from "@tanstack/react-query";

export function CSuitePage() {
  const {
    data = [],
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["client", "searches", "csuite"],
    queryFn: () => clientApi.searches("csuite"),
  });
  return (
    <div className="animate-fade-up space-y-8">
      <PageHeader title="C-Suite" description="Chief-level mandates across the portfolio." />
      {isError ? (
        <ErrorState onRetry={() => refetch()}>Couldn't load these roles.</ErrorState>
      ) : (
        <SearchList rows={data} loading={isLoading} />
      )}
    </div>
  );
}
